// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__tzRuk","headers":"otherPropertyItemNew_headers__Tc34I","semiTitle":"otherPropertyItemNew_semiTitle__4Emaa"};